import { render, staticRenderFns } from "./MemoMath.vue?vue&type=template&id=60e16eb5&scoped=true&lang=pug&"
import script from "./MemoMath.vue?vue&type=script&lang=ts&"
export * from "./MemoMath.vue?vue&type=script&lang=ts&"
import style0 from "./MemoMath.vue?vue&type=style&index=0&id=60e16eb5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e16eb5",
  null
  
)

export default component.exports